module.exports = __webpack_public_path__ + "Badge_ChefsKitchen-14eb610864c2e73561f84adbcdea3787.svg";